import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { selectUser } from "../services/userSlice";

interface Props {
  children: JSX.Element;
}

export default function PrivateRoute({ children }: Props) {
  const user = useSelector(selectUser);

  if (user !== null && !user?.emailVerified) {
    return (
      <Navigate
        to="/verify-email"
        replace
      />
    );
  } else if (!user || user === null) {
    return (
      <Navigate
        to="/login"
        replace
      />
    );
  }

  return children;
}
